import { inject, Injectable } from "@angular/core";
import { ClinicDoctorsService } from "../../../api/services";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { ResponseClinicDto } from "../../../api/models";

const TENANT = environment.tenant;

@Injectable({
  providedIn: "root",
})
export class ClinicDoctorsApiService {
  /** The clinic-doctors service */
  private readonly _clinicDoctorsService: ClinicDoctorsService =
    inject(ClinicDoctorsService);

  /**
   * Gets clinics for a specific doctor
   * @param doctorId the doctor id
   * @returns the clinics associated with the doctor
   */
  public getClinicsForDoctor$(
    doctorId: string,
  ): Observable<ResponseClinicDto[]> {
    return this._clinicDoctorsService.clinicDoctorControllerGetClinicsForDoctor(
      {
        tenant: TENANT,
        doctorId,
      },
    );
  }
}
